{
  "schemaVersion": 2,
  "id": "lobby-public",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; slicePx are source PNG pixels at 2x",
  "sourceRoot": "repository root",
  "reference": "art/src/lobby-elements-2026-09-22/meet-lobby-mockup.png",
  "brief": "art/src/lobby-elements-2026-09-22/BRIEF-MEET.md",
  "defaultTheme": "meet",
  "defaultState": "waiting",
  "themes": {
    "meet": {
      "filter": "none",
      "hueRotate": 0,
      "accent": "#35e0ff",
      "background": "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png",
      "logo": "apps/client/public/art/room-logos/lobby-meet.png"
    },
    "flirt": {
      "filter": "hue-rotate(150deg)",
      "hueRotate": 150,
      "accent": "#ff4fa8",
      "background": "art/src/lobby-backgrounds-2026-09-22/flirt.png",
      "logo": "apps/client/public/art/room-logos/lobby-flirt.png"
    }
  },
  "textContract": {
    "renderer": "Ink, fixed CSS role classes (OD-035/036)",
    "roles": {
      "title": {
        "font": "Nunito",
        "size": 48,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 60
      },
      "eyebrow": {
        "font": "Nunito",
        "size": 26,
        "weight": 600,
        "trackingEm": 0.18,
        "lineHeight": 33
      },
      "body": {
        "font": "Nunito",
        "size": 30,
        "weight": 500,
        "trackingEm": 0,
        "lineHeight": 38
      },
      "caption": {
        "font": "Nunito",
        "size": 26,
        "weight": 500,
        "trackingEm": 0,
        "lineHeight": 33
      },
      "chip": {
        "font": "Nunito",
        "size": 24,
        "weight": 700,
        "trackingEm": 0,
        "lineHeight": 35
      },
      "code": {
        "font": "Nunito",
        "size": 100,
        "weight": 900,
        "trackingEm": 0.02,
        "lineHeight": 125
      },
      "button": {
        "font": "Nunito",
        "size": 32,
        "weight": 800,
        "trackingEm": 0,
        "lineHeight": 40
      },
      "action": {
        "font": "Nunito",
        "size": 56,
        "weight": 400,
        "trackingEm": 0,
        "lineHeight": 70
      }
    },
    "position": "x/y/w/h are the static lane. capCenterY is the optical uppercase-height centre, not a font size.",
    "sizing": "All sizes come from the fixed role. No per-text cap/font overrides, stretch, shrink-to-fit, runtime DOM measurements or JS style rewriting.",
    "overflow": "Player names and region may use CSS ellipsis at maxW; ordinary labels and mm:ss never shrink.",
    "regionRole": "title (Nunito 48/800), white, preserve proper-name case",
    "numberColor": "One centred body lane with separate spans; numeral spans only use the table accent CSS class. Text itself is not hue-filtered."
  },
  "colors": {
    "white": "#ffffff",
    "unavailable": "#8f9ac4",
    "onAccent": "#09121a"
  },
  "textClasses": {
    "table-accent": {
      "byTheme": {
        "meet": "#35e0ff",
        "flirt": "#ff4fa8"
      }
    },
    "on-accent": {
      "color": "#09121a"
    }
  },
  "pieces": {
    "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png",
      "pixelW": 941,
      "pixelH": 1672,
      "alpha": false,
      "reused": true,
      "sha256": "1977c6fb5fd06b36b32990714dacfd6dba65e8088668b418816a2db8722f0344"
    },
    "apps/client/public/art/room-logos/lobby-meet.png": {
      "path": "apps/client/public/art/room-logos/lobby-meet.png",
      "pixelW": 880,
      "pixelH": 506,
      "alpha": true,
      "reused": true,
      "sha256": "2c2b00b66741162909b1f7658a63acfb00054a0d306f436b599a1df3cca8748b"
    },
    "apps/client/public/art/ui-head/bg@2x.png": {
      "path": "apps/client/public/art/ui-head/bg@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "reused": true,
      "sha256": "ed70ede39d5d34e59c6619b7d84082814b69058bbd929b4ce0d895185220f820"
    },
    "apps/client/public/art/ui-head/icon-back@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-back@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "reused": true,
      "sha256": "026c480685d45fca3639e55537d5a3d3557f3ffb72cfbbf6e6e84354ad954694"
    },
    "apps/client/public/art/ui-head/icon-sound-on@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "reused": true,
      "sha256": "4cbe7e8ec9c7d9ab1dc14c1046c12fe03684e9fc1853b3514e18acbc014671ff"
    },
    "sticker.ul.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ul.png",
      "pixelW": 328,
      "pixelH": 308,
      "alpha": true,
      "reused": true,
      "sha256": "54f64ea3c8e610d9681118192d797074b5f005d3f3b570cf75d4760c1678660d"
    },
    "sticker.ur.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ur.png",
      "pixelW": 396,
      "pixelH": 308,
      "alpha": true,
      "reused": true,
      "sha256": "0112673e6dbd9a38ab1c48d9a523973d6ccba02b38e3dd02cc6edd7728cd8f8e"
    },
    "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "reused": true,
      "sha256": "b4bdaaa8028ddd65a6e322f0967ef7547cf485f3ccf98af7e7dfd8306a3df62b"
    },
    "seat.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/seat.ring.png",
      "pixelW": 520,
      "pixelH": 440,
      "alpha": true,
      "reused": true,
      "sha256": "a877661bef9d18762c7047a1d42578936b0cb112c960190d7e70590617eb57af"
    },
    "pill.short.png": {
      "path": "art/src/lobby-elements-2026-09-22/pill.short.png",
      "pixelW": 400,
      "pixelH": 128,
      "alpha": true,
      "reused": true,
      "sha256": "fed3d6d3a56ba5abf42980b9af2eac1bb4818098e816cff2c87dfd9302584dc9",
      "slicePx": {
        "left": 70,
        "right": 70,
        "top": 0,
        "bottom": 0
      }
    },
    "open.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/open.ring.png",
      "pixelW": 520,
      "pixelH": 412,
      "alpha": true,
      "reused": true,
      "sha256": "231723111d9a140fe4bcb298b231aa27b8b02e232b123426555733c16ba53025"
    },
    "board9.png": {
      "path": "art/src/lobby-elements-2026-09-22/board9.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "reused": true,
      "sha256": "ff3a8f9078435101fdc3c4ce5d5ecdaa17e6de5999278710861bf503700665fb",
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      }
    },
    "leaf.l.png": {
      "path": "art/src/lobby-elements-2026-09-22/leaf.l.png",
      "pixelW": 240,
      "pixelH": 320,
      "alpha": true,
      "reused": true,
      "sha256": "94b315d93178bcbfbdacf34d3a3cf61c74939a10126c65197df4a6e6c1b2d649"
    },
    "leaf.r.png": {
      "path": "art/src/lobby-elements-2026-09-22/leaf.r.png",
      "pixelW": 240,
      "pixelH": 320,
      "alpha": true,
      "reused": true,
      "sha256": "b4b422e794877779e552f9b60dfa1a87abb6e652b03d67cc11e3c27b35bde66a"
    },
    "icon.clock.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.clock.png",
      "pixelW": 80,
      "pixelH": 80,
      "alpha": true,
      "reused": true,
      "sha256": "5617a2e8154691b49305170c56d2af023670f67e7379dac5f015518d9362a29b"
    },
    "icon.people.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.people.png",
      "pixelW": 140,
      "pixelH": 140,
      "alpha": true,
      "reused": true,
      "sha256": "ef41c39512f5c508dc3e871a6f7a96edfd6f342a1f17c152be0f3d55de3500e0"
    },
    "cta.plate.png": {
      "path": "art/src/lobby-elements-2026-09-22/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "alpha": true,
      "reused": true,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "slicePx": {
        "left": 331,
        "right": 331,
        "top": 0,
        "bottom": 0
      }
    },
    "small.button.png": {
      "path": "art/src/lobby-elements-2026-09-22/small.button.png",
      "pixelW": 812,
      "pixelH": 228,
      "alpha": true,
      "reused": true,
      "sha256": "c0a274c1d527673a77055107fae0cbd3149ec8fbbe9fb2128129515ba86479ed",
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      }
    },
    "icon.book.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.book.png",
      "pixelW": 192,
      "pixelH": 192,
      "alpha": true,
      "reused": true,
      "sha256": "187c91e21438fcdef7e0c8af970f174dbab6d94f4c9666f8c35784c9f079713d"
    },
    "icon.door.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.door.png",
      "pixelW": 140,
      "pixelH": 140,
      "alpha": true,
      "reused": true,
      "sha256": "ebfd41dcad51e61ecfb63d4feebc6f64dc3f87ae9077dcc50329a6a3691d0072"
    },
    "art/src/lobby-backgrounds-2026-09-22/flirt.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/flirt.png",
      "pixelW": 941,
      "pixelH": 1672,
      "alpha": false,
      "reused": true,
      "sha256": "f023a3e12052d43e677134eab969463c18efc5a60f9c7bdf36681ca73ad06ab7"
    },
    "apps/client/public/art/room-logos/lobby-flirt.png": {
      "path": "apps/client/public/art/room-logos/lobby-flirt.png",
      "pixelW": 880,
      "pixelH": 508,
      "alpha": true,
      "reused": true,
      "sha256": "557d3a3ca5d3a0be84cb8fc707bdf5bd6f5701fa4d9617e95dadcdeebe8770e0"
    },
    "apps/client/public/art/ui-head/icon-sound-off@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
      "pixelW": 276,
      "pixelH": 276,
      "alpha": true,
      "reused": true,
      "sha256": "25814b1deba5c0188b2840bb696bc15f34d5fbaeaf21f049790b4b13e2d0b249"
    },
    "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "reused": true,
      "sha256": "f75ed324dfe890fd03136dfd43898d0c24b526d648e6655bce2303e136e3c004"
    },
    "icon.info.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.info.png",
      "pixelW": 640,
      "pixelH": 640,
      "alpha": true,
      "source": "the owner's /var/www/play.saynoway.com/icons/circle-info-solid.png (fa-solid circle-info), 23.9.2026"
    }
  },
  "elements": [
    {
      "id": "background",
      "piece": "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "render": "image",
      "tint": "none",
      "z": 0,
      "themeBinding": "themes[theme].background"
    },
    {
      "id": "logo",
      "piece": "apps/client/public/art/room-logos/lobby-meet.png",
      "x": 267,
      "y": 8,
      "w": 440,
      "h": 253,
      "render": "image",
      "tint": "none",
      "z": 60,
      "themeBinding": "themes[theme].logo"
    },
    {
      "id": "back.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": false
    },
    {
      "id": "back.icon",
      "piece": "apps/client/public/art/ui-head/icon-back@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sound.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 60,
      "mirrorX": true
    },
    {
      "id": "sound.icon",
      "piece": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "render": "image",
      "tint": "none",
      "z": 61
    },
    {
      "id": "sticker.ul",
      "piece": "sticker.ul.png",
      "x": 36,
      "y": 156,
      "w": 200,
      "h": 187.805,
      "render": "image",
      "tint": "none",
      "z": 10
    },
    {
      "id": "sticker.ur",
      "piece": "sticker.ur.png",
      "x": 726,
      "y": 153,
      "w": 198,
      "h": 154,
      "render": "image",
      "tint": "none",
      "z": 10
    },
    {
      "id": "seat1.avatar",
      "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
      "x": 122,
      "y": 397,
      "w": 200,
      "h": 200,
      "render": "image",
      "tint": "none",
      "z": 18,
      "clip": "circle",
      "sourceCrop": {
        "x": 24,
        "y": 0,
        "w": 208,
        "h": 208
      },
      "opacity": 1,
      "binding": {
        "kind": "player-avatar-expression",
        "seat": 1,
        "exampleAvatarId": "snw-cast-0056"
      }
    },
    {
      "id": "seat1.ring",
      "piece": "seat.ring.png",
      "x": 80.938,
      "y": 377.41,
      "w": 282.667,
      "h": 239.18,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "opacity": 1,
      "referenceCenter": {
        "x": 222,
        "y": 497
      },
      "referenceRadius": 106
    },
    {
      "id": "seat1.pill",
      "piece": "pill.short.png",
      "x": 132,
      "y": 548,
      "w": 180,
      "h": 60,
      "render": "3-slice",
      "tint": "cyan",
      "z": 24,
      "slicePx": {
        "left": 70,
        "right": 70,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "opacity": 1
    },
    {
      "id": "seat2.ring",
      "piece": "open.ring.png",
      "x": 316.441,
      "y": 375.691,
      "w": 307.71,
      "h": 243.801,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 470,
        "y": 497
      },
      "referenceRadius": 104
    },
    {
      "id": "seat3.ring",
      "piece": "open.ring.png",
      "x": 562.964,
      "y": 375.525,
      "w": 310.669,
      "h": 246.145,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 718,
        "y": 498
      },
      "referenceRadius": 105
    },
    {
      "id": "seat4.ring",
      "piece": "open.ring.png",
      "x": 66.964,
      "y": 622.525,
      "w": 310.669,
      "h": 246.145,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 222,
        "y": 745
      },
      "referenceRadius": 105
    },
    {
      "id": "seat5.ring",
      "piece": "open.ring.png",
      "x": 313.964,
      "y": 620.525,
      "w": 310.669,
      "h": 246.145,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 469,
        "y": 743
      },
      "referenceRadius": 105
    },
    {
      "id": "seat6.ring",
      "piece": "open.ring.png",
      "x": 564.441,
      "y": 621.691,
      "w": 307.71,
      "h": 243.801,
      "render": "image",
      "tint": "cyan",
      "z": 20,
      "referenceCenter": {
        "x": 718,
        "y": 743
      },
      "referenceRadius": 104
    },
    {
      "id": "gather.plate",
      "piece": "board9.png",
      "x": 46.5,
      "y": 970,
      "w": 847.5,
      "h": 240,
      "render": "border-image",
      "tint": "cyan",
      "z": 20,
      "slicePx": {
        "top": 128,
        "right": 128,
        "bottom": 128,
        "left": 128
      },
      "borderWidthStage": 64,
      "fill": true,
      "repeat": "stretch",
      "outset": 0,
      "interactive": false,
      "semantics": "status",
      "referenceTubeBox": {
        "x": 44,
        "y": 902,
        "w": 852,
        "h": 304
      }
    },
    {
      "id": "gather.leaf.ul",
      "piece": "leaf.l.png",
      "x": 78,
      "y": 1004,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.28
    },
    {
      "id": "gather.leaf.ur",
      "piece": "leaf.r.png",
      "x": 783,
      "y": 1004,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.28
    },
    {
      "id": "gather.leaf.ll",
      "piece": "leaf.l.png",
      "x": 78,
      "y": 1080,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.28
    },
    {
      "id": "gather.leaf.lr",
      "piece": "leaf.r.png",
      "x": 783,
      "y": 1080,
      "w": 80,
      "h": 106.667,
      "render": "image",
      "tint": "cyan",
      "z": 21,
      "opacity": 0.28
    },
    {
      "id": "gather.clock",
      "piece": "icon.clock.png",
      "x": 264.5,
      "y": 1093,
      "w": 32,
      "h": 32,
      "render": "image",
      "tint": "none",
      "z": 30
    },
    {
      "id": "gather.people",
      "piece": "icon.people.png",
      "x": 313.5,
      "y": 1139,
      "w": 32,
      "h": 32,
      "render": "image",
      "tint": "none",
      "z": 30
    },
    {
      "id": "invite.button",
      "piece": "cta.plate.png",
      "x": 42.163,
      "y": 1260,
      "w": 855.191,
      "h": 157.155,
      "render": "3-slice",
      "tint": "cyan",
      "z": 30,
      "slicePx": {
        "left": 331,
        "right": 331,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 49,
        "y": 1243,
        "w": 842,
        "h": 121
      },
      "sourceFilter": "hue-rotate(140deg)",
      "sourceHueRotate": 140,
      "filterOrder": [
        "sourceFilter",
        "themeFilter"
      ]
    },
    {
      "id": "invite.people",
      "piece": "icon.people.png",
      "x": 272,
      "y": 1294,
      "w": 88,
      "h": 88,
      "render": "image",
      "tint": "none",
      "z": 40,
      "colorTreatment": "on-accent",
      "filter": "brightness(0)"
    },
    {
      "id": "howto.button",
      "piece": "small.button.png",
      "x": 45.684,
      "y": 1500,
      "w": 423.088,
      "h": 104,
      "render": "3-slice",
      "tint": "cyan",
      "z": 30,
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 56,
        "y": 1410,
        "w": 402,
        "h": 83
      }
    },
    {
      "id": "howto.icon",
      "piece": "icon.info.png",
      "x": 109,
      "y": 1526,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 40,
      "sourceFilter": "brightness(0) invert(1)"
    },
    {
      "id": "leave.button",
      "piece": "small.button.png",
      "x": 472.684,
      "y": 1500,
      "w": 424.088,
      "h": 104,
      "render": "3-slice",
      "tint": "cyan",
      "z": 30,
      "slicePx": {
        "left": 229,
        "right": 229,
        "top": 0,
        "bottom": 0
      },
      "capRule": "renderedHeight * sourceSlice / sourceHeight",
      "referenceTubeBox": {
        "x": 485,
        "y": 1410,
        "w": 401,
        "h": 83
      }
    },
    {
      "id": "leave.icon",
      "piece": "icon.door.png",
      "x": 522,
      "y": 1528,
      "w": 50,
      "h": 50,
      "render": "image",
      "tint": "none",
      "z": 40
    }
  ],
  "texts": [
    {
      "id": "region",
      "text": "Finland",
      "role": "title",
      "className": "t-title",
      "x": 170,
      "y": 286,
      "w": 600,
      "h": 60,
      "capCenterY": 316,
      "maxW": 600,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "ellipsis",
      "binding": {
        "kind": "table-region-display-name",
        "example": "Finland"
      },
      "case": "preserve",
      "roleDecision": "title=48/800, white; name=36 would subordinate the region too much relative to this header."
    },
    {
      "id": "seat1.name",
      "text": "YOU",
      "role": "chip",
      "className": "t-chip",
      "x": 164,
      "y": 562,
      "w": 116,
      "h": 35,
      "capCenterY": 579.5,
      "maxW": 116,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "ellipsis",
      "binding": {
        "kind": "player-name",
        "seat": 1,
        "selfLabel": "YOU",
        "fallback": "Player",
        "maxChars": null,
        "overflow": "CSS ellipsis; no font resizing"
      }
    },
    {
      "id": "gather.heading",
      "text": "GATHERING PLAYERS",
      "role": "eyebrow",
      "className": "t-eyebrow",
      "x": 210.5,
      "y": 1009,
      "w": 520,
      "h": 33,
      "capCenterY": 1025.5,
      "maxW": 520,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "gather.body",
      "text": "1 of 6 seated • 5 seats open",
      "role": "body",
      "className": "t-body",
      "x": 250,
      "y": 1049,
      "w": 440,
      "h": 38,
      "capCenterY": 1068,
      "maxW": 580,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "spans": [
        {
          "text": "1",
          "binding": "seatedCount",
          "className": "table-accent"
        },
        {
          "text": " of ",
          "color": "#ffffff"
        },
        {
          "text": "6",
          "binding": "capacity",
          "className": "table-accent"
        },
        {
          "text": " seated • ",
          "color": "#ffffff"
        },
        {
          "text": "5",
          "binding": "openSeatCount",
          "className": "table-accent"
        },
        {
          "text": " seats open",
          "color": "#ffffff"
        }
      ],
      "binding": {
        "kind": "seat-counts",
        "capacity": 6,
        "seatedCount": 1,
        "openSeatCount": 5
      },
      "composition": "One centred lane. Only numeral spans receive table-accent. All spans inherit body 30/500."
    },
    {
      "id": "gather.rule",
      "text": "Starts 30 s after 3 are seated",
      "role": "caption",
      "className": "t-caption",
      "x": 305.5,
      "y": 1095,
      "w": 370,
      "h": 33,
      "capCenterY": 1111.5,
      "maxW": 370,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "binding": {
        "kind": "house-start-rule",
        "earlySeconds": 30,
        "minSeated": 3
      },
      "icon": "gather.clock",
      "group": {
        "centerX": 470.5,
        "gap": 13
      }
    },
    {
      "id": "gather.full",
      "text": "Full table starts in 10 s",
      "role": "caption",
      "className": "t-caption",
      "x": 354.5,
      "y": 1141,
      "w": 272,
      "h": 33,
      "capCenterY": 1157.5,
      "maxW": 272,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "binding": {
        "kind": "full-table-start-rule",
        "seconds": 10
      },
      "icon": "gather.people",
      "group": {
        "centerX": 470.5,
        "gap": 14
      }
    },
    {
      "id": "gather.countdown",
      "text": "00:29",
      "role": "code",
      "className": "t-code table-accent",
      "x": 255.5,
      "y": 1080,
      "w": 430,
      "h": 125,
      "capCenterY": 1142.5,
      "maxW": 430,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "colorByTheme": "accent",
      "binding": {
        "kind": "server-start-countdown",
        "source": "server startAt - synchronized now",
        "format": "mm:ss",
        "round": "ceil seconds, clamp at zero",
        "example": "00:29"
      },
      "stateVisibility": "countdown or starting only"
    },
    {
      "id": "invite.label",
      "text": "INVITE",
      "role": "action",
      "className": "t-action on-accent",
      "x": 377,
      "y": 1309,
      "w": 292,
      "h": 70,
      "capCenterY": 1344,
      "maxW": 292,
      "align": "center",
      "color": "#09121a",
      "z": 46,
      "overflow": "visible"
    },
    {
      "id": "howto.label",
      "text": "HOW TO PLAY",
      "role": "button",
      "className": "t-button",
      "x": 165,
      "y": 1534,
      "w": 234,
      "h": 40,
      "capCenterY": 1554,
      "maxW": 234,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    },
    {
      "id": "leave.label",
      "text": "LEAVE TABLE",
      "role": "button",
      "className": "t-button",
      "x": 574,
      "y": 1534,
      "w": 278,
      "h": 40,
      "capCenterY": 1554,
      "maxW": 278,
      "align": "center",
      "color": "#ffffff",
      "z": 46,
      "overflow": "visible",
      "size": 30
    }
  ],
  "hitTargets": [
    {
      "id": "back",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "leave-table",
      "ariaLabel": "Back to the tables",
      "enabled": true
    },
    {
      "id": "sound",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "toggle-sound",
      "ariaLabel": "Sound on",
      "enabled": true
    },
    {
      "id": "seat1",
      "x": 103,
      "y": 401,
      "w": 238,
      "h": 238,
      "enabled": false,
      "action": null,
      "ariaLabel": "YOU, seated",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat2",
      "x": 351,
      "y": 401,
      "w": 238,
      "h": 238,
      "enabled": true,
      "action": "invite",
      "ariaLabel": "Open seat. Invite someone.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat3",
      "x": 599,
      "y": 402,
      "w": 238,
      "h": 238,
      "enabled": true,
      "action": "invite",
      "ariaLabel": "Open seat. Invite someone.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat4",
      "x": 103,
      "y": 649,
      "w": 238,
      "h": 238,
      "enabled": true,
      "action": "invite",
      "ariaLabel": "Open seat. Invite someone.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat5",
      "x": 350,
      "y": 647,
      "w": 238,
      "h": 238,
      "enabled": true,
      "action": "invite",
      "ariaLabel": "Open seat. Invite someone.",
      "interactionRules": "seatInteractionRules"
    },
    {
      "id": "seat6",
      "x": 599,
      "y": 647,
      "w": 238,
      "h": 238,
      "enabled": true,
      "action": "invite",
      "ariaLabel": "Open seat. Invite someone.",
      "interactionRules": "seatInteractionRules"
    }
  ],
  "seatVariants": {
    "1": {
      "open": {
        "elements": [
          {
            "id": "seat1.ring",
            "piece": "open.ring.png",
            "x": 65.488,
            "y": 393.358,
            "w": 313.627,
            "h": 248.489,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 106
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 122,
            "y": 417,
            "w": 200,
            "h": 200,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 80.938,
            "y": 397.41,
            "w": 282.667,
            "h": 239.18,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 106
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 132,
            "y": 568,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 164,
            "y": 582,
            "w": 116,
            "h": 35,
            "capCenterY": 599.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 122,
            "y": 417,
            "w": 200,
            "h": 200,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 1,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 80.938,
            "y": 397.41,
            "w": 282.667,
            "h": 239.18,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 106
          },
          {
            "id": "seat1.pill",
            "piece": "pill.short.png",
            "x": 132,
            "y": 568,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "role": "chip",
            "className": "t-chip",
            "x": 164,
            "y": 582,
            "w": 116,
            "h": 35,
            "capCenterY": 599.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    },
    "2": {
      "open": {
        "elements": [
          {
            "id": "seat2.ring",
            "piece": "open.ring.png",
            "x": 316.441,
            "y": 395.691,
            "w": 307.71,
            "h": 243.801,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 104
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 372,
            "y": 419,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 331.6,
            "y": 399.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 104
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 380,
            "y": 566,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 412,
            "y": 580,
            "w": 116,
            "h": 35,
            "capCenterY": 597.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 372,
            "y": 419,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 2,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 331.6,
            "y": 399.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 104
          },
          {
            "id": "seat2.pill",
            "piece": "pill.short.png",
            "x": 380,
            "y": 566,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 412,
            "y": 580,
            "w": 116,
            "h": 35,
            "capCenterY": 597.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    },
    "3": {
      "open": {
        "elements": [
          {
            "id": "seat3.ring",
            "piece": "open.ring.png",
            "x": 562.964,
            "y": 395.525,
            "w": 310.669,
            "h": 246.145,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 105
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 619,
            "y": 419,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "seat.ring.png",
            "x": 578.269,
            "y": 399.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 105
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 628,
            "y": 568,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat3.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 660,
            "y": 582,
            "w": 116,
            "h": 35,
            "capCenterY": 599.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat3.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 619,
            "y": 419,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 3,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat3.ring",
            "piece": "seat.ring.png",
            "x": 578.269,
            "y": 399.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 105
          },
          {
            "id": "seat3.pill",
            "piece": "pill.short.png",
            "x": 628,
            "y": 568,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat3.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 660,
            "y": 582,
            "w": 116,
            "h": 35,
            "capCenterY": 599.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 3,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    },
    "4": {
      "open": {
        "elements": [
          {
            "id": "seat4.ring",
            "piece": "open.ring.png",
            "x": 66.964,
            "y": 652.525,
            "w": 310.669,
            "h": 246.145,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 105
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 123,
            "y": 676,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "seat.ring.png",
            "x": 82.269,
            "y": 656.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 105
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 132,
            "y": 825,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat4.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 164,
            "y": 839,
            "w": 116,
            "h": 35,
            "capCenterY": 856.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat4.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 123,
            "y": 676,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 4,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat4.ring",
            "piece": "seat.ring.png",
            "x": 82.269,
            "y": 656.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 105
          },
          {
            "id": "seat4.pill",
            "piece": "pill.short.png",
            "x": 132,
            "y": 825,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat4.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 164,
            "y": 839,
            "w": 116,
            "h": 35,
            "capCenterY": 856.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 4,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    },
    "5": {
      "open": {
        "elements": [
          {
            "id": "seat5.ring",
            "piece": "open.ring.png",
            "x": 313.964,
            "y": 650.525,
            "w": 310.669,
            "h": 246.145,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 105
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 370,
            "y": 674,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "seat.ring.png",
            "x": 329.269,
            "y": 654.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 105
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 823,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat5.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 837,
            "w": 116,
            "h": 35,
            "capCenterY": 854.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat5.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 370,
            "y": 674,
            "w": 198,
            "h": 198,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 5,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat5.ring",
            "piece": "seat.ring.png",
            "x": 329.269,
            "y": 654.538,
            "w": 280,
            "h": 236.923,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 105
          },
          {
            "id": "seat5.pill",
            "piece": "pill.short.png",
            "x": 379,
            "y": 823,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat5.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 411,
            "y": 837,
            "w": 116,
            "h": 35,
            "capCenterY": 854.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 5,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    },
    "6": {
      "open": {
        "elements": [
          {
            "id": "seat6.ring",
            "piece": "open.ring.png",
            "x": 564.441,
            "y": 651.691,
            "w": 307.71,
            "h": 243.801,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "referenceRadius": 104
          }
        ],
        "texts": [],
        "hasNamePill": false,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Open seat. Invite someone."
      },
      "occupied": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 620,
            "y": 675,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 1,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "seat.ring.png",
            "x": 579.6,
            "y": 655.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 1,
            "referenceRadius": 104
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 628,
            "y": 822,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 1
          }
        ],
        "texts": [
          {
            "id": "seat6.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 660,
            "y": 836,
            "w": 116,
            "h": 35,
            "capCenterY": 853.5,
            "maxW": 116,
            "align": "center",
            "color": "#ffffff",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, seated"
      },
      "offline": {
        "elements": [
          {
            "id": "seat6.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0056/neutral.webp",
            "x": 620,
            "y": 675,
            "w": 196,
            "h": 196,
            "render": "image",
            "tint": "none",
            "z": 18,
            "clip": "circle",
            "sourceCrop": {
              "x": 24,
              "y": 0,
              "w": 208,
              "h": 208
            },
            "opacity": 0.45,
            "binding": {
              "kind": "player-avatar-expression",
              "seat": 6,
              "exampleAvatarId": "snw-cast-0056"
            }
          },
          {
            "id": "seat6.ring",
            "piece": "seat.ring.png",
            "x": 579.6,
            "y": 655.667,
            "w": 277.333,
            "h": 234.666,
            "render": "image",
            "tint": "cyan",
            "z": 20,
            "opacity": 0.5,
            "referenceRadius": 104
          },
          {
            "id": "seat6.pill",
            "piece": "pill.short.png",
            "x": 628,
            "y": 822,
            "w": 180,
            "h": 60,
            "render": "3-slice",
            "tint": "cyan",
            "z": 24,
            "slicePx": {
              "left": 70,
              "right": 70,
              "top": 0,
              "bottom": 0
            },
            "capRule": "renderedHeight * sourceSlice / sourceHeight",
            "opacity": 0.62
          }
        ],
        "texts": [
          {
            "id": "seat6.name",
            "text": "Player",
            "role": "chip",
            "className": "t-chip",
            "x": 660,
            "y": 836,
            "w": 116,
            "h": 35,
            "capCenterY": 853.5,
            "maxW": 116,
            "align": "center",
            "color": "#8f9ac4",
            "z": 46,
            "overflow": "ellipsis",
            "binding": {
              "kind": "player-name",
              "seat": 6,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxChars": null,
              "overflow": "CSS ellipsis; no font resizing"
            }
          }
        ],
        "hasNamePill": true,
        "hasStatusTag": false,
        "interactionRules": "seatInteractionRules",
        "accessibleLabel": "Player, offline"
      }
    }
  },
  "states": {
    "waiting": {
      "elementOverrides": {},
      "textOverrides": {},
      "hitOverrides": {},
      "hiddenElements": [],
      "hiddenTexts": [
        "gather.countdown"
      ],
      "values": {
        "seatedCount": 1,
        "capacity": 6,
        "openSeatCount": 5,
        "remaining": null,
        "region": "Finland"
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "when": "connected && lobbyPhase == gathering && server.startAt == null",
      "cta": {
        "action": "invite",
        "label": "INVITE",
        "role": "action",
        "enabled": true
      },
      "notes": [
        "Counts come from real seats; never infer startAt from counts."
      ]
    },
    "countdown": {
      "elementOverrides": {},
      "textOverrides": {
        "gather.heading": {
          "text": "STARTING IN"
        }
      },
      "hitOverrides": {},
      "hiddenElements": [
        "gather.clock",
        "gather.people"
      ],
      "hiddenTexts": [
        "gather.rule",
        "gather.full"
      ],
      "values": {
        "seatedCount": 3,
        "capacity": 6,
        "openSeatCount": 3,
        "remaining": "00:29",
        "region": "Finland"
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "occupied",
          "name": "Ada",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "occupied",
          "name": "Bob",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "when": "connected && lobbyPhase == gathering && server.startAt != null",
      "cta": {
        "action": "invite",
        "label": "INVITE",
        "role": "action",
        "enabled": true
      },
      "notes": [
        "The seat-count line stays. The countdown replaces exactly the two caption rows and their icons.",
        "A full table uses the server-promised 10-second start; never run a second timer. If server cancels startAt, return to waiting."
      ]
    },
    "starting": {
      "elementOverrides": {
        "invite.button": {
          "brightness": 0.58,
          "opacity": 0.95
        },
        "invite.people": {
          "opacity": 0.6
        },
        "invite.chevron": {
          "opacity": 0.6
        },
        "leave.button": {
          "brightness": 0.58,
          "opacity": 0.7
        },
        "leave.icon": {
          "opacity": 0.55
        }
      },
      "textOverrides": {
        "gather.heading": {
          "text": "STARTING IN"
        },
        "gather.countdown": {
          "text": "00:00"
        }
      },
      "hitOverrides": {
        "invite": {
          "action": null,
          "enabled": false
        },
        "leave": {
          "action": null,
          "enabled": false
        },
        "back": {
          "action": null,
          "enabled": false
        }
      },
      "hiddenElements": [
        "gather.clock",
        "gather.people"
      ],
      "hiddenTexts": [
        "gather.rule",
        "gather.full"
      ],
      "values": {
        "seatedCount": 3,
        "capacity": 6,
        "openSeatCount": 3,
        "remaining": "00:00",
        "region": "Finland"
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "occupied",
          "name": "Ada",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "occupied",
          "name": "Bob",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "when": "server lobby phase transitions to starting; not merely a client-side zero",
      "cta": {
        "action": null,
        "label": "INVITE",
        "role": "action",
        "enabled": false
      },
      "notes": [
        "The seat-count line stays. The countdown replaces exactly the two caption rows and their icons.",
        "A full table uses the server-promised 10-second start; never run a second timer. If server cancels startAt, return to waiting."
      ],
      "textStyleOverrides": {
        "invite.label": {
          "opacity": 0.6
        },
        "leave.label": {
          "color": "#8f9ac4"
        }
      },
      "seatInputEnabled": false
    },
    "reconnecting": {
      "elementOverrides": {
        "invite.button": {
          "brightness": 0.58,
          "opacity": 0.95
        },
        "invite.people": {
          "opacity": 0.6
        },
        "invite.chevron": {
          "opacity": 0.6
        }
      },
      "textOverrides": {
        "gather.heading": {
          "text": "CONNECTION LOST"
        },
        "gather.body": {
          "text": "Reconnecting…",
          "spans": [],
          "binding": {
            "kind": "literal"
          },
          "color": "#ffffff"
        },
        "gather.rule": {
          "text": "Please wait",
          "x": 255.5,
          "w": 430,
          "maxW": 430,
          "binding": {
            "kind": "literal"
          }
        }
      },
      "hitOverrides": {
        "invite": {
          "action": null,
          "enabled": false
        }
      },
      "hiddenElements": [
        "gather.clock",
        "gather.people"
      ],
      "hiddenTexts": [
        "gather.full",
        "gather.countdown"
      ],
      "values": {
        "seatedCount": 1,
        "capacity": 6,
        "openSeatCount": 5,
        "remaining": null,
        "region": "Finland"
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "when": "!connected && lastKnownRoom != null",
      "cta": {
        "action": null,
        "label": "INVITE",
        "role": "action",
        "enabled": false
      },
      "seatInputEnabled": false
    },
    "loading": {
      "elementOverrides": {
        "invite.button": {
          "brightness": 0.58,
          "opacity": 0.95
        },
        "invite.people": {
          "opacity": 0.6
        },
        "invite.chevron": {
          "opacity": 0.6
        }
      },
      "textOverrides": {
        "gather.heading": {
          "text": "CONNECTING"
        },
        "gather.rule": {
          "text": "Joining the table…",
          "x": 215.5,
          "w": 510,
          "maxW": 510,
          "binding": {
            "kind": "literal"
          }
        }
      },
      "hitOverrides": {
        "invite": {
          "action": null,
          "enabled": false
        }
      },
      "hiddenElements": [
        "gather.clock",
        "gather.people"
      ],
      "hiddenTexts": [
        "gather.full",
        "gather.countdown"
      ],
      "values": {
        "seatedCount": 0,
        "capacity": 6,
        "openSeatCount": 6,
        "remaining": null,
        "region": "Finland"
      },
      "seats": {
        "1": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "when": "lastKnownRoom == null",
      "cta": {
        "action": null,
        "label": "INVITE",
        "role": "action",
        "enabled": false
      },
      "seatInputEnabled": false
    }
  },
  "measurements": {
    "reference": "meet-lobby-mockup.png",
    "stage": {
      "w": 941,
      "h": 1672
    },
    "method": "Direct RGB sampling; cyan neon ridge maxima in recorded scan strips, circular response across 180 angles, glyph-core bounds in recorded ROIs. Diffuse glow excluded.",
    "uncertaintyStagePx": {
      "straightRidge": 1,
      "circlesAndGlyphCores": 2
    },
    "boards": {
      "gather": {
        "x0": 44,
        "x1": 896,
        "y0": 902,
        "y1": 1206,
        "scanStrips": {
          "x": [
            34,
            55,
            980,
            1120
          ],
          "right": [
            885,
            905,
            980,
            1120
          ],
          "top": [
            890,
            911,
            200,
            735
          ],
          "bottom": [
            1196,
            1217,
            200,
            735
          ]
        }
      },
      "cta": {
        "x0": 49,
        "x1": 891,
        "y0": 1243,
        "y1": 1364,
        "scanStrips": {
          "x": [
            37,
            57,
            1297,
            1310
          ],
          "right": [
            881,
            902,
            1297,
            1310
          ],
          "top": [
            1230,
            1253,
            210,
            740
          ],
          "bottom": [
            1355,
            1378,
            210,
            740
          ]
        }
      },
      "howto": {
        "x0": 56,
        "x1": 458,
        "y0": 1410,
        "y1": 1493,
        "scanStrips": {
          "x": [
            42,
            63,
            1445,
            1461
          ],
          "right": [
            450,
            470,
            1445,
            1461
          ],
          "top": [
            1401,
            1424,
            140,
            372
          ],
          "bottom": [
            1484,
            1504,
            140,
            372
          ]
        }
      },
      "leave": {
        "x0": 485,
        "x1": 886,
        "y0": 1410,
        "y1": 1493,
        "scanStrips": {
          "x": [
            474,
            493,
            1445,
            1461
          ],
          "right": [
            879,
            899,
            1445,
            1461
          ],
          "top": [
            1401,
            1424,
            572,
            800
          ],
          "bottom": [
            1484,
            1504,
            572,
            800
          ]
        }
      },
      "you": {
        "x0": 157,
        "x1": 288,
        "y0": 570,
        "y1": 609,
        "scanStrips": {
          "x": [
            149,
            165,
            586,
            597
          ],
          "right": [
            279,
            297,
            586,
            597
          ],
          "top": [
            563,
            579,
            192,
            256
          ],
          "bottom": [
            602,
            617,
            192,
            256
          ]
        }
      }
    },
    "texts": [
      {
        "id": "region",
        "roi": [
          356,
          276,
          228,
          53
        ],
        "threshold": "mixed",
        "ink": {
          "x": 373,
          "y": 281,
          "w": 195,
          "h": 44,
          "centerX": 470,
          "centerY": 302.5,
          "pixels": 3911
        }
      },
      {
        "id": "seat1.name",
        "roi": [
          187,
          577,
          68,
          28
        ],
        "threshold": "white",
        "ink": {
          "x": 197,
          "y": 582,
          "w": 50,
          "h": 18,
          "centerX": 221.5,
          "centerY": 590.5,
          "pixels": 320
        }
      },
      {
        "id": "gather.heading",
        "roi": [
          245,
          933,
          452,
          46
        ],
        "threshold": "white",
        "ink": {
          "x": 260,
          "y": 943,
          "w": 422,
          "h": 24,
          "centerX": 470.5,
          "centerY": 954.5,
          "pixels": 2121
        }
      },
      {
        "id": "gather.body",
        "roi": [
          128,
          994,
          682,
          58
        ],
        "threshold": "mixed",
        "ink": {
          "x": 146,
          "y": 1005,
          "w": 651,
          "h": 46,
          "centerX": 471,
          "centerY": 1027.5,
          "pixels": 8316
        }
      },
      {
        "id": "gather.rule",
        "roi": [
          280,
          1074,
          464,
          43
        ],
        "threshold": "white",
        "ink": {
          "x": 290,
          "y": 1082,
          "w": 436,
          "h": 26,
          "centerX": 507.5,
          "centerY": 1094.5,
          "pixels": 2802
        }
      },
      {
        "id": "gather.full",
        "roi": [
          332,
          1129,
          363,
          45
        ],
        "threshold": "white",
        "ink": {
          "x": 345,
          "y": 1137,
          "w": 334,
          "h": 25,
          "centerX": 511.5,
          "centerY": 1149,
          "pixels": 1968
        }
      },
      {
        "id": "invite.label",
        "roi": [
          379,
          1276,
          224,
          56
        ],
        "threshold": "dark",
        "ink": {
          "x": 394,
          "y": 1283,
          "w": 191,
          "h": 40,
          "centerX": 489,
          "centerY": 1302.5,
          "pixels": 3980
        }
      },
      {
        "id": "howto.label",
        "roi": [
          204,
          1435,
          207,
          37
        ],
        "threshold": "white",
        "ink": {
          "x": 218,
          "y": 1444,
          "w": 181,
          "h": 18,
          "centerX": 308,
          "centerY": 1452.5,
          "pixels": 1080
        }
      },
      {
        "id": "leave.label",
        "roi": [
          639,
          1435,
          191,
          37
        ],
        "threshold": "white",
        "ink": {
          "x": 652,
          "y": 1444,
          "w": 163,
          "h": 18,
          "centerX": 733,
          "centerY": 1452.5,
          "pixels": 1056
        }
      }
    ],
    "iconInk": [
      {
        "id": "gather.clock",
        "roi": [
          211,
          1067,
          59,
          55
        ],
        "threshold": "white",
        "ink": {
          "x": 220,
          "y": 1073,
          "w": 44,
          "h": 43,
          "centerX": 241.5,
          "centerY": 1094,
          "pixels": 498
        }
      },
      {
        "id": "gather.people",
        "roi": [
          258,
          1121,
          71,
          56
        ],
        "threshold": "white",
        "ink": {
          "x": 266,
          "y": 1129,
          "w": 55,
          "h": 38,
          "centerX": 293,
          "centerY": 1147.5,
          "pixels": 1158
        }
      },
      {
        "id": "invite.people",
        "roi": [
          208,
          1268,
          102,
          64
        ],
        "threshold": "dark",
        "ink": {
          "x": 218,
          "y": 1274,
          "w": 82,
          "h": 54,
          "centerX": 258.5,
          "centerY": 1300.5,
          "pixels": 2612
        }
      },
      {
        "id": "invite.chevron",
        "roi": [
          687,
          1277,
          42,
          55
        ],
        "threshold": "dark",
        "ink": {
          "x": 696,
          "y": 1285,
          "w": 21,
          "h": 37,
          "centerX": 706,
          "centerY": 1303,
          "pixels": 257
        }
      },
      {
        "id": "howto.icon",
        "roi": [
          115,
          1422,
          72,
          59
        ],
        "threshold": "white",
        "ink": {
          "x": 125,
          "y": 1432,
          "w": 50,
          "h": 41,
          "centerX": 149.5,
          "centerY": 1452,
          "pixels": 434
        }
      },
      {
        "id": "leave.icon",
        "roi": [
          548,
          1424,
          60,
          55
        ],
        "threshold": "white",
        "ink": {
          "x": 557,
          "y": 1431,
          "w": 40,
          "h": 41,
          "centerX": 576.5,
          "centerY": 1451,
          "pixels": 390
        }
      }
    ],
    "seats": [
      {
        "id": "seat1",
        "cx": 222,
        "cy": 497,
        "r": 106,
        "score": 30945
      },
      {
        "id": "seat2",
        "cx": 470,
        "cy": 497,
        "r": 104,
        "score": 29143
      },
      {
        "id": "seat3",
        "cx": 718,
        "cy": 498,
        "r": 105,
        "score": 28764
      },
      {
        "id": "seat4",
        "cx": 222,
        "cy": 745,
        "r": 105,
        "score": 28814
      },
      {
        "id": "seat5",
        "cx": 469,
        "cy": 743,
        "r": 105,
        "score": 28900
      },
      {
        "id": "seat6",
        "cx": 718,
        "cy": 743,
        "r": 104,
        "score": 29491
      }
    ]
  },
  "filterContract": {
    "scope": "Only raster elements tagged tint=cyan receive the theme filter. Never filter the whole lobby or text layers.",
    "goldCTA": {
      "piece": "cta.plate.png",
      "scope": "Public layout only",
      "sourceFilter": "hue-rotate(140deg)",
      "themeFilter": "none on Meet; hue-rotate(150deg) on Flirt",
      "order": "Gold PNG -> inner source filter hue-rotate(140deg) -> outer table filter. Keep the two filter stages separate; do not replace with one combined hue rotation.",
      "newAsset": false
    },
    "icons": "CTA people and chevron use brightness(0) for dark glyphs. Other icon pixels stay original."
  },
  "notes": [
    "All assets are reused. No new piece is needed.",
    "Shared back/sound at 16,9 and 812,9, 120x120; logo 267,8 width 440.",
    "No lower stickers; no footer; no pill or word for open seats.",
    "The house starts the match. No public state exposes START MATCH or a host control.",
    "board9 is a non-interactive notice board; only the separate invite/howto/leave pieces are buttons.",
    "Friends and Date layouts and source PNGs are unchanged.",
    "schemaVersion 2 is a design handoff: fixed lane y/h plus capCenterY, sourceFilter before the theme filter, explicit state and border-image geometry. No application integration was performed.",
    "Owner 23.9.2026 (friends-lobby-host-alone): the name pill 180×60 centred on the avatar circle with its bottom on the circle's inner bottom (seat 1: left 131 top 620), the name word 24px with its lane 14 below the pill top (634).",
    "Owner 23.9.2026: the HOW TO PLAY icon is fa-solid circle-info everywhere (one element); the small plates' labels 30px.",
    "Owner 23.9.2026: a button is one element — its plate's box is the <button> (KitButton); the separate hit targets invite, howto, leave are gone so the tap area cannot drift from the plate.",
    "Owner 23.9.2026: the CTA chevron is gone here too (\"Chevron right on turha\") — one CTA element; small-plate labels size 30 on the lane.",
    "Owner 23.9.2026: the finished Friends lobby is the visual guide — its values carried over to the same elements here: stickers 25,142 w171 / 763,143 w174; small plates 1500 (Friends boxes), icons 109,1526 / 522,1528 w50, labels 165 / 574 @1534 size 30; the CTA plate box 42.163,1260 855.191×157.155, icon top 1294 w88, word top 1309. The Meet-only parts (region, seat rows, gathering board, INVITE composition) go to Codex with Friends as the guide.",
    "Codex 23.9.2026 (meet-finish/VALUES-meet-proposed.md, Friends as the guide on the owner's words): region 286; seats +20; the gathering board 46.5,970 847.5×240 with the Friends status-board rhythm; INVITE icon+word re-centred; seat hit boxes +20.",
    "Owner 23.9.2026 (Meet, devtools verbatim): left slogan 36,156 w200; right slogan 726,153 w198. Flirt has its own slogans (KitSlogans), so this is Meet only.",
    "23.9.2026: the name lane 116 (was 106) so every 8-character name fits the 180 pill — Samantha is 112 px at 24; names are ≤ 8 chars (profile rule)."
  ],
  "auxiliaryStates": {
    "sound_off": {
      "elementOverrides": {
        "sound.icon": {
          "piece": "apps/client/public/art/ui-head/icon-sound-off@2x.png"
        }
      },
      "hitOverrides": {
        "sound": {
          "ariaLabel": "Sound off"
        }
      }
    },
    "full_table": {
      "baseState": "countdown",
      "values": {
        "seatedCount": 6,
        "openSeatCount": 0,
        "remaining": "00:09"
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "occupied",
          "name": "Ada",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "occupied",
          "name": "Bob",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "occupied",
          "name": "Cara",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "occupied",
          "name": "Dee",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "occupied",
          "name": "Eli",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      }
    },
    "offline_player": {
      "baseState": "waiting",
      "values": {
        "seatedCount": 2,
        "openSeatCount": 4
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "offline",
          "name": "Alexandertallname",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      }
    },
    "countdown_cancelled": {
      "baseState": "waiting",
      "values": {
        "seatedCount": 2,
        "openSeatCount": 4
      },
      "seats": {
        "1": {
          "variant": "occupied",
          "name": "YOU",
          "isSelf": true,
          "avatar": "snw-cast-0056"
        },
        "2": {
          "variant": "occupied",
          "name": "Ada",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "3": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "4": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "5": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        },
        "6": {
          "variant": "open",
          "name": "",
          "isSelf": false,
          "avatar": "snw-cast-0001"
        }
      },
      "reason": "Server cleared startAt; restore the two caption rows."
    }
  },
  "seatInteractionRules": {
    "source": "apps/client/src/screens/LobbyPublic.tsx; existing actions",
    "selection": "first matching rule, real player IDs; never compare the YOU display string",
    "rules": [
      {
        "when": "seatInputEnabled == false",
        "enabled": false,
        "action": null
      },
      {
        "when": "variant == open",
        "enabled": true,
        "action": "invite"
      },
      {
        "when": "playerId == viewerId",
        "enabled": false,
        "action": null
      },
      {
        "when": "playerId != viewerId",
        "enabled": true,
        "action": "report-player"
      }
    ]
  },
  "stateSelection": {
    "priority": [
      "loading",
      "reconnecting",
      "starting",
      "countdown",
      "waiting"
    ],
    "countdown": "Only authoritative server startAt promises a start, not a locally counted threshold.",
    "capacity": 6
  },
  "stateDataContract": {
    "fixturesOnly": [
      "values",
      "seats"
    ],
    "runtime": "Real roster, avatar expression, region and startAt come from room state. Preserve the server seat numbers. Theme affects only scene/logo/accent and tagged art, never geometry."
  },
  "layoutChangesFromReference": [
    {
      "element": "logo",
      "reason": "Owner explicitly fixes logo at 267,8 width 440; painted reference is only approximate."
    },
    {
      "element": "region",
      "reason": "Brief requests white and title/name choice. Use title=48/800 and the measured centre; preserve Finland case."
    },
    {
      "element": "gather.body",
      "reason": "Brief fixes body=30/500; source lettering is larger. Preserve its row position and centre, with ample margins."
    },
    {
      "element": "gather.clock + gather.rule / gather.people + gather.full",
      "reason": "Each icon+caption pair is centred as one group at fixed caption=26. Their separate source icon positions move inward because the fixed-role text is narrower."
    },
    {
      "element": "howto.label / leave.label",
      "reason": "Fixed button=32 requires wider lanes than the painted labels. Plate boxes stay measured; icon and text lanes remain separate."
    },
    {
      "element": "gather.plate",
      "reason": "Current board9 has fixed 64-unit corner cells; its rounded rectangle reuses the established shape, without tracing a new frame."
    }
  ],
  "verification": {
    "referencedPiecesVerified": 25,
    "newPieces": 0,
    "states": 5,
    "themes": 2,
    "seatVariants": 18,
    "renderedViews": 18,
    "uniqueFixedRoleTextRuns": 40,
    "allTextRunsFit": true,
    "enabledHitOverlaps": 0,
    "smallestHitCssPxAt360": 44.378,
    "identicalThemeGeometry": true,
    "boardSlicePx": 128,
    "boardCornerStage": 64,
    "previewMethod": "2x raster composition of original assets, FreeType rendering of local WOFF2 fonts, reduced to 1x. Not a browser screenshot.",
    "appCodeTestsOrBrowserTestsRun": false,
    "previews": {
      "meet": {
        "file": "art/src/lobby-elements-2026-09-22/preview-layout-public-meet.png",
        "w": 941,
        "h": 1672,
        "state": "waiting",
        "sha256": "75331075437355fa41cd34d0666795fa41b2be6ca956bc1ea6621ca56b6105e4"
      },
      "flirt": {
        "file": "art/src/lobby-elements-2026-09-22/preview-layout-public-flirt.png",
        "w": 941,
        "h": 1672,
        "state": "waiting",
        "sha256": "d3917669c9c8a987da1f2076c287f3cd8ee77d5a8d6838945f1486f3c5291160"
      }
    },
    "mainTextMetrics": [
      {
        "id": "region",
        "text": "Finland",
        "requestedText": "Finland",
        "role": "title",
        "fontSize": 48,
        "weight": 800,
        "lane": {
          "x": 170,
          "y": 272.5,
          "w": 600,
          "h": 60
        },
        "ink": {
          "x": 388.25,
          "y": 284.25,
          "w": 163.5,
          "h": 36.5
        },
        "capCenterY": 302.5,
        "capHeight": 34.5,
        "maxW": 600,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "gather.heading",
        "text": "GATHERING PLAYERS",
        "requestedText": "GATHERING PLAYERS",
        "role": "eyebrow",
        "fontSize": 26,
        "weight": 600,
        "lane": {
          "x": 210.5,
          "y": 938,
          "w": 520,
          "h": 33
        },
        "ink": {
          "x": 296.75,
          "y": 945,
          "w": 347.5,
          "h": 19.5
        },
        "capCenterY": 954.5,
        "capHeight": 19,
        "maxW": 520,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "gather.body",
        "text": "1 of 6 seated • 5 seats open",
        "requestedText": "1 of 6 seated • 5 seats open",
        "role": "body",
        "fontSize": 30,
        "weight": 500,
        "lane": {
          "x": 180.5,
          "y": 1005.5,
          "w": 580,
          "h": 38
        },
        "ink": {
          "x": 281.75,
          "y": 1013.75,
          "w": 377.5,
          "h": 27.5
        },
        "capCenterY": 1024.5,
        "capHeight": 21.5,
        "maxW": 580,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "gather.rule",
        "text": "Starts 30 s after 3 are seated",
        "requestedText": "Starts 30 s after 3 are seated",
        "role": "caption",
        "fontSize": 26,
        "weight": 500,
        "lane": {
          "x": 312,
          "y": 1078,
          "w": 370,
          "h": 33
        },
        "ink": {
          "x": 326,
          "y": 1085,
          "w": 342,
          "h": 19.5
        },
        "capCenterY": 1094.5,
        "capHeight": 19,
        "maxW": 370,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "gather.full",
        "text": "Full table starts in 10 s",
        "requestedText": "Full table starts in 10 s",
        "role": "caption",
        "fontSize": 26,
        "weight": 500,
        "lane": {
          "x": 368.5,
          "y": 1132.5,
          "w": 272,
          "h": 33
        },
        "ink": {
          "x": 369.5,
          "y": 1139.5,
          "w": 270,
          "h": 19.5
        },
        "capCenterY": 1149,
        "capHeight": 19,
        "maxW": 272,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "invite.label",
        "text": "INVITE",
        "requestedText": "INVITE",
        "role": "action",
        "fontSize": 56,
        "weight": 400,
        "lane": {
          "x": 345,
          "y": 1267.5,
          "w": 292,
          "h": 70
        },
        "ink": {
          "x": 390,
          "y": 1282.25,
          "w": 202,
          "h": 42.5
        },
        "capCenterY": 1302.5,
        "capHeight": 41.5,
        "maxW": 292,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "howto.label",
        "text": "HOW TO PLAY",
        "requestedText": "HOW TO PLAY",
        "role": "button",
        "fontSize": 32,
        "weight": 800,
        "lane": {
          "x": 194,
          "y": 1432.5,
          "w": 234,
          "h": 40
        },
        "ink": {
          "x": 195,
          "y": 1441,
          "w": 232,
          "h": 23.5
        },
        "capCenterY": 1452.5,
        "capHeight": 23,
        "maxW": 234,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "leave.label",
        "text": "LEAVE TABLE",
        "requestedText": "LEAVE TABLE",
        "role": "button",
        "fontSize": 32,
        "weight": 800,
        "lane": {
          "x": 618,
          "y": 1432.5,
          "w": 234,
          "h": 40
        },
        "ink": {
          "x": 627.75,
          "y": 1441,
          "w": 214.5,
          "h": 23.5
        },
        "capCenterY": 1452.5,
        "capHeight": 23,
        "maxW": 234,
        "fits": true,
        "ellipsized": false
      },
      {
        "id": "seat1.name",
        "text": "YOU",
        "requestedText": "YOU",
        "role": "chip",
        "fontSize": 28,
        "weight": 700,
        "lane": {
          "x": 169,
          "y": 573,
          "w": 106,
          "h": 35
        },
        "ink": {
          "x": 193,
          "y": 580,
          "w": 58,
          "h": 21
        },
        "capCenterY": 590.5,
        "capHeight": 20,
        "maxW": 106,
        "fits": true,
        "ellipsized": false
      }
    ],
    "countdownMetrics": {
      "id": "gather.countdown",
      "text": "00:29",
      "requestedText": "00:29",
      "role": "code",
      "fontSize": 100,
      "weight": 900,
      "lane": {
        "x": 255.5,
        "y": 1059,
        "w": 430,
        "h": 125
      },
      "ink": {
        "x": 336.25,
        "y": 1085.25,
        "w": 268.5,
        "h": 73.5
      },
      "capCenterY": 1121.5,
      "capHeight": 71.5,
      "maxW": 430,
      "fits": true,
      "ellipsized": false
    }
  }
}
